import React from "react";
import { getDeviceIcon, getDeviceDisplayName } from "../../utils";

const CurrentSession = ({ currentSession }) => {
  return (
    <div className="current-session-container">
      <div className="session-header">Current Session</div>
      <div className="session-item">
        <div className="session-icon-container current">
          {getDeviceIcon(currentSession.os, currentSession.deviceType)}
        </div>
        <div className="session-details">
          <div className="session-device-name">
            {getDeviceDisplayName(
              currentSession.browser,
              currentSession.os,
              currentSession.deviceType
            )}
          </div>
          <div className="session-location">
            {currentSession?.location?.city || "Lahore"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentSession;
